/**
 * Employee Benefits - PDF Presentation Configuration
 *
 * Slide-by-slide configuration with:
 * - Page numbers
 * - Pre-scripted narrations for avatar TTS
 */

export const employeeBenefitsPresentation = {
  pdfUrl: 'https://entri-studyplans.s3.ap-south-1.amazonaws.com/media/pdf_notes/2024/11/04/Employee_Benefits.pdf',

  slides: [
    {
      page: 1,
      title: 'Title Slide',
      narration: `Welcome to Module 7: Employee Benefits. ... At Entri, we know that our success is built on the well-being and happiness of our team. ... This module outlines the perks and benefits designed to support you not just as an employee, but as a person ... covering everything from your health to your hobbies.`,
    },
    {
      page: 2,
      title: 'Health & Financial Support',
      narration: `Let's start with your health and security. ... We offer a comprehensive Group Medical Insurance plan ... that covers you, your spouse, and your children ... with a generous insured amount of 5 lakhs. ... We also prioritize mental wellness through 'YourDOST,' ... a platform where you can access free counseling and emotional support from experts. ... Additionally, we have a Welfare Fund ... to provide a financial safety net for you during unexpected emergencies.`,
    },
    {
      page: 3,
      title: 'Growth & Rewards',
      narration: `We love it when you help us build our team and grow personally. ... With our Referral Bonus, ... you get rewarded when you refer a candidate who successfully completes 3 months with us. ... For the readers among you, ... the Entri Book Club is a fantastic community. ... We even support your habit with a quarterly allowance of 500 rupees to buy books of your choice.`,
    },
    {
      page: 4,
      title: 'Lifestyle Benefits',
      narration: `Beyond the basics, ... we have a suite of lifestyle benefits designed to make your time at Entri enjoyable and balanced. ... Let's take a look at how we support your daily life and well-being.`,
    },
    {
      page: 5,
      title: 'Wellness & Connection',
      narration: `Our Wellness Club is committed to your overall health, ... offering activities like yoga sessions to help you thrive physically and mentally. ... To keep us connected as a team, ... we host monthly virtual 'Employee Happy Hours'. ... These are a great way to unwind, chat, ... and just have fun with your colleagues outside of work tasks.`,
    },
    {
      page: 6,
      title: 'Community & Culture',
      narration: `Culture is huge here. ... We celebrate a wide range of festivals ... from Onam and Diwali to Christmas and Eid ... honoring the diversity of our team. ... For those who love to stay active, ... our Sports Club organizes activities like Cricket, Football, and Badminton. ... And to keep you fueled, ... our Lunch Program provides nutritious and delicious meals every day.`,
    },
    {
      page: 7,
      title: 'Fitness & Recreation',
      narration: `Finally, we want you to stay fit and relaxed. ... Our Corporate Gym Plans give you access to premier fitness facilities through local partnerships. ... Inside the office, you can take a break with our recreational facilities, ... which include Table Tennis, Carom, board games, and even a library. ... These are there for you to recharge whenever you need a break. ... That covers all the employee benefits at Entri!`,
    },
  ],
};

export default employeeBenefitsPresentation;
